export class GroupConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên nhóm khách hàng',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/group/group.const.ts